import { Chip, List, Paper } from '@material-ui/core';
import { ArrowDownward, ArrowUpward } from '@material-ui/icons';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { dynamicSort } from '@commonClient2/services/sort';
import { EmployeeBidProfileColumnNames } from '../../../Enums';
import BidCard from './BidCard';
/**
    * @param {{profiles:EmployeeBidProfile.IEmployeeBidProfile[],employeeBidProfileColumn:EmployeeBidProfileColumn}} param0
    * @returns
    */
const BidsSection = ({ profiles, employeeBidProfileColumn }) => {
    const [isAscending, setIsAscending] = useState(false);
    const { t: tBidSection } = useTranslation('shiftBidding', { keyPrefix: 'employee.bidSelection.bidSection' });
    // @ts-ignore
    const onTitleClick = (e) => {
        e.stopPropagation();
        setIsAscending(!isAscending);
    };
    const sortingField = 'submissionPeriodStartDate';
    const sortedProfiles = profiles.sort(dynamicSort(isAscending ? sortingField : `-${sortingField}`));
    return (
        <Paper
            className="bid-column-wrapper"
            elevation={1}
        >
            <div
                className="bid-status-wrapping"
                onClick={onTitleClick}
            >
                <div>
                    <span>{EmployeeBidProfileColumnNames[employeeBidProfileColumn]}</span>
                    <Chip label={profiles.length} />
                </div>
                <div>
                    <span>{tBidSection('date').toLocaleUpperCase()}</span>
                    {isAscending ? <ArrowUpward /> : <ArrowDownward />}
                </div>
            </div>
            <List
                dense={false}
                className="bid-profiles-list"
            >
                {sortedProfiles.map((sp) => (
                    <BidCard
                        key={sp.profileId}
                        profile={sp}
                        employeeBidProfileColumn={employeeBidProfileColumn}
                    />
                ))}
            </List>
        </Paper>
    );
};
export default BidsSection;
